/* eslint-disable no-undef */
const sandboxDataCollectorUrl = 'https://tst.kaptcha.com';
const prodDataCollectorUrl = 'https://ssl.kaptcha.com';

const isProd = (env) => env === 'production';

const addKountScriptElement = ({ env, kountAccountId, kountSessionId }) => {
  const baseUrl = isProd(env) ? prodDataCollectorUrl : sandboxDataCollectorUrl;
  const kountScriptUrl = new URL(`${baseUrl}/collect/sdk`);
  kountScriptUrl.searchParams.append('m', kountAccountId);
  if (kountSessionId) {
    kountScriptUrl.searchParams.append('m', kountSessionId);
  }

  const kountScript = document.createElement('script');
  kountScript.setAttribute('class', 'kaxsdc');
  kountScript.setAttribute('data-event', 'load');
  kountScript.setAttribute('type', 'text/javascript');
  kountScript.setAttribute('src', kountScriptUrl.href);

  document.body.append(kountScript);

  return kountScript;
};

export default async function getFraudSessionId({
  env,
  kountAccountId,
  kountSessionId,
}) {
  return new Promise((resolve, reject) => {
    const kountScript = addKountScriptElement({
      env,
      kountAccountId,
      kountSessionId,
    });

    kountScript.onload = () => {
      const client = new ka.ClientSDK();
      client.setupCallback({
        'collect-begin': (params) => {
          const { MercSessId } = params;
          resolve(MercSessId);
        },
      });
      client.autoLoadEvents();
    };
    kountScript.onerror = () => {
      reject(new Error('Error attempting to mount Kount script'));
    };
  });
}
